module.exports = __webpack_public_path__ + "media/flags/bo-d18ef8e4.svg";